'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Button } from '@startengine/design-system.ui.button';

export const LinkTag = styled('a')(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  textDecoration: 'none',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    textAlign: 'left',
  },
}));

export const HeroTitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.black,
  letterSpacing: '2px',
  [theme.breakpoints.up('sm')]: {
    fontWeight: 400,
    fontSize: '32px',
    lineHeight: '36px',
    letterSpacing: '0.07em',
    marginTop: '48px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '45px',
    lineHeight: '50px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '60px',
    lineHeight: '65px',
    letterSpacing: '0.07em',
  },
}));

export const HeroSubtitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.tabsTextColor,
  textAlign: 'center',
  display: 'flex',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  margin: '8px 0 0 0 !important',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
    textAlign: 'left',
  },
  [theme.breakpoints.up('lg')]: {
    display: 'block',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    textAlign: 'left',
  },
}));

export const HeroAdditionalText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.tabsTextColor,
  display: 'block',
}));

export const HeroButton = styled(Button)(({ theme }) => ({
  borderRadius: '16px',
  height: '48px',
  whiteSpace: 'nowrap',
  [theme.breakpoints.between('sm', 'md')]: {
    borderRadius: '12px',
  },
}));

export const ButtonText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '22.9px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px',
  },
}));

export const BaseTypography = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '8px',
  lineHeight: '14px',
  letterSpacing: '0.05px',
  color: theme.palette.common.divider,
  zIndex: 1,
  [theme.breakpoints.up('sm')]: {
    fontSize: '5px',
    lineHeight: '10px',
    marginBottom: '10px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '8px',
    lineHeight: '14px',
  },
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center !important',
  ' *': {
    textAlign: 'center !important',
  },
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'left',
    margin: '0',
    textAlign: 'left !important',
    ' *': {
      textAlign: 'left !important',
    },
  },
}));
